export default __webpack_public_path__ + "static/media/ameen.14d15610.png";